<svg class="stacked-area-chart"></svg>

<div id="stacked-area-chart-tooltip">
  <p>{{ 'sp.revamp.assetGraph.tooltipText.expected' | translate }} {{ tooltipData.expected.toFixed(0) | thousand: currency }}</p>
  <p>{{ 'sp.revamp.assetGraph.tooltipText.gain' | translate }} {{ tooltipData.potential.toFixed(0) | thousand: currency }}</p>
  <p>{{ 'sp.revamp.assetGraph.tooltipText.loss' | translate }} {{ tooltipData.loss.toFixed(0) | thousand: currency }}</p>
</div>

<div class="stacked-area-chart__legend" [ngClass]="{'two-lines': !isEnglish()}">
  <div
    class="stacked-area-chart__legend-item"
    *ngFor="let item of ['expectedCaseWithout','expectedCase']; let i = index"
    (click)="switchSelection(i); track(i)"
    [class.inactive]="currentChip !== i"
    [class.without]="i === 1"
  >
    {{ (i === 0 ? 'sp.revamp.assetGraph.monthlyDeposits' : 'sp.revamp.assetGraph.noMonthlyDeposits') | translate }}
  </div>
</div>
